import Vue from 'vue'
import Router from 'vue-router'
//import index from '../views/index.vue'
//import search from '../views/search.vue'
//import rank from '../views/rank.vue'
//import rankPage from '../views/rankPage.vue'
Vue.use(Router)

const router = new Router({
	
	//mode: 'history',
	//base: __dirname,
  routes: [
    {
      path: '/index',
      name: 'index',
      component: require('../views/index.vue')
    },
    {
      path: '/search',
      name: 'search',
      component: require('../views/search.vue')
    },
    {
      path: '/rank',
      name: 'rank',
      component: require('../views/rank.vue')
    },
    {
      path: '/rankPage',
      name: 'rankPage',
      component: require('../views/rankPage.vue')
    },
    {
      path: '/plist',
      name: 'plist',
      component: require('../views/plist.vue')
    },
    {
      path: '/plistPage',
      name: 'plistPage',
      component: require('../views/plistPage.vue')
    },
    {
      path: '/singer',
      name: 'singer',
      component: require('../views/singer.vue')
    },
    {
      path: '/singer_list',
      name: 'singer_list',
      component: require('../views/singer_list.vue')
    },
    {
      path: '/singer_info',
      name: 'singer_info',
      component: require('../views/singer_info.vue')
    },
    {
      path:'*',
      redirect:'/index'
    }
  ],
	scrollBehavior (to, from, savedPosition) {
  	return { x: 0, y: 0 }
	}
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js